import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { BigCalendarModalBodyGlobal } from './components/modal/BigCalendarModalBodyGlobal'
import {
  BigCalendarModalFooterGlobal,
  BigCalendarModalFooterGlobalProps,
} from './components/modal/BigCalendarModalFooterGlobal'
import { computeHouseAvailabilityGlobalDefaultValues } from './helpers/compute-house-availability-global'
import { BigCalendarProps } from '../shared/calendar/BigCalendar'
import { BigCalendarContainer } from '../shared/calendar/components/container/BigCalendarContainer'
import { BigCalendarHeaderICalendarImportProps } from '../shared/calendar/components/header/components/BigCalendarHeaderImportButton'
import { CalendarPlaceHolder } from '../shared/calendar/components/placeholder/CalendarPlaceHolder'
import {
  BigCalendarModalGlobalFormProps,
  useBigCalencarFormContext,
} from '../shared/calendar/utils/use-big-calendar-form'

export const BigCalendarGlobal = ({
  house,
  onUpdateICalendarUrls,
  onUpsertHouseAvailability,
  onUpsertManyHouseAvailabilities,
  isFormDisabled,
}: Pick<BigCalendarHeaderICalendarImportProps, 'onUpdateICalendarUrls'> &
  Pick<BigCalendarProps, 'house'> &
  Pick<
    BigCalendarModalFooterGlobalProps,
    | 'onUpsertHouseAvailability'
    | 'onUpsertManyHouseAvailabilities'
    | 'isFormDisabled'
  >) => {
  const { modalFormProps } = useBigCalencarFormContext()

  const {
    options: { studyDay, nightlyTrip, corporateEvening },
  } = house

  const isCalendarDisabled =
    !studyDay.isEnabled && !nightlyTrip.isEnabled && !corporateEvening.isEnabled

  const hasError =
    !modalFormProps ||
    !modalFormProps.formValues ||
    modalFormProps?.kind !== 'global'

  const methods = useForm<BigCalendarModalGlobalFormProps>({
    ...(hasError ? {} : { defaultValues: modalFormProps }),
  })
  const { reset } = methods

  useEffect(() => {
    if (!hasError) {
      reset(computeHouseAvailabilityGlobalDefaultValues(modalFormProps))
    }
  }, [modalFormProps?.formValues])

  return (
    <>
      {isCalendarDisabled ? (
        <CalendarPlaceHolder />
      ) : (
        <FormProvider {...methods}>
          <BigCalendarContainer
            house={house}
            onUpdateICalendarUrls={onUpdateICalendarUrls}
            modalContent={{
              body: (
                <BigCalendarModalBodyGlobal isFormDisabled={isFormDisabled} />
              ),
              footer: (
                <BigCalendarModalFooterGlobal
                  isFormDisabled={isFormDisabled}
                  onUpsertHouseAvailability={onUpsertHouseAvailability}
                  onUpsertManyHouseAvailabilities={
                    onUpsertManyHouseAvailabilities
                  }
                />
              ),
            }}
          />
        </FormProvider>
      )}
    </>
  )
}
